// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import LexAudioProcessor from 'aws/lex/LexAudioProcessor';
import LexProcessingAction, { baseActionConfig } from './LexProcessingAction';
import AudioContext from '../../../sound/AudioContext';

/**
 * Base class for Lex Audio Processing actions.
 */
class LexAudioProcessingAction extends LexProcessingAction {

  /**
   * Creates a new LexAudioProcessingAction.
   * @param {Object} options Options for action.
   */
  constructor(options) {
    super(...arguments); // also support (id, settings) parameters used with FSM
    // For log output. Note that this.constructor.name doesn't work when the
    // code is minified.
    /**
     * Name of the action.
     * @type {string}
     */
    this.actionName = 'LexAudioProcessingAction';
  }

  _getContentType() {
    return 'audio/x-l16; rate=16000';
  }

  _process(fsm, entity) {
    const input = entity.getData('audio');
    const lexAudioProcessor = new LexAudioProcessor(input, AudioContext.getContext().sampleRate);
    const inputStream = lexAudioProcessor.process();
    const lexSettings = this._getLexConfig(entity, inputStream);

    return this._processWithLex(fsm, entity, lexSettings);
  }
}

LexAudioProcessingAction.external = Object.assign({}, baseActionConfig, {
  key: 'LexAudioProcessing',
  type: 'Dialogue',
  name: 'Send Audio Input to Dialogue Bot',
  description: 'Sends audio input to an Amazon Lex Bot configured in the Dialogue Component.',
});

LexAudioProcessingAction.register();

export default LexAudioProcessingAction;
